import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
interface ButtonProps {
  children?: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  href?: string;
  onClick?: () => void;
  className?: string;
}
export function Button({
  children = 'Easy Class Signup',
  className = '',
  variant = 'primary',
  fullWidth = false,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold uppercase tracking-wide transition-colors rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-red-700 text-white hover:bg-red-800 focus:ring-red-700 shadow-lg shadow-red-900/20',
    secondary: 'bg-neutral-900 text-white hover:bg-neutral-800 focus:ring-neutral-900',
    outline: 'border-2 border-red-700 text-red-700 hover:bg-red-50 focus:ring-red-700'
  };
  const content = <>
      {children}
      <ArrowRight className="ml-2 h-5 w-5" strokeWidth={3} data-id="element-178" />
    </>;
  const classes = `${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <Link to={href} data-id="element-179">
        <motion.div whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className={classes} data-id="element-180">
          {content}
        </motion.div>
      </Link>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} onClick={onClick} {...props} data-id="element-181">
      {content}
    </motion.button>;
}